// FastAPI returns `detail` as a string for HTTPExceptions (e.g. "Email already
// registered") but as an ARRAY of {loc, msg, ...} objects for 422 validation
// errors. Rendering the array directly (e.g. `new Error(detail)` or
// `setError(detail)`) produces the useless "[object Object]". Normalize any
// shape to a human-readable message here.
export const apiErrorMessage = (detail, fallback = 'Something went wrong') => {
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const msg = detail
      .map((d) => (d && typeof d === 'object' ? d.msg : String(d)))
      .filter(Boolean)
      .join('; ');
    return msg || fallback;
  }
  // FastAPI validation errors use `.msg`; this codebase's own structured
  // HTTPException bodies (quota.enforce_count_quota, error_handlers.py, etc.)
  // use `.message` instead — both must unwrap or their text never reaches
  // the user (see OnboardingWizard.js's silent 403-on-quota bug).
  if (typeof detail === 'object' && (detail.msg || detail.message)) {
    return detail.msg || detail.message;
  }
  return fallback;
};
